import {
    removeDiacritics,
    removeLanguagePath,
} from 'wanderu-utils';

const HOMEPAGE_PATH = '/';

function isHomePage(path) {
    const nonLocalizedPath = removeDiacritics(removeLanguagePath(path));
    return nonLocalizedPath === HOMEPAGE_PATH;
}

function isLandingPage(path) {
    const landingPageSegments = [
        'bus',
        'train',
        'ferry',
        'flight',
        'carrier',
        'travel',
        'stations',
        'airport-shuttles'
    ];
    const pageTravelMode = path.split('/').filter(Boolean)[1];

    return landingPageSegments.some((urlPartial) => pageTravelMode?.includes(urlPartial));
}

export {
    isHomePage,
    isLandingPage,
};
